var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [
        _vm._v(_vm._s(_vm.$ct("calendar-hover-field-values"))),
      ]),
      _vm.userConf.CalendarToShowHoverFields.length == 0
        ? _c("div", { key: "empty", staticClass: "empty" }, [
            _vm._v(" " + _vm._s(_vm.$ct("no-fields-added")) + " "),
          ])
        : _vm._e(),
      _c(
        "w-sortable",
        {
          attrs: {
            tag: "w-list",
            "target-class": "handle",
            items: _vm.userConf.CalendarToShowHoverFields,
            "keep-in-y": "",
          },
        },
        [
          _vm._l(_vm.userConf.CalendarToShowHoverFields, function (conf) {
            return _c(
              "w-list-item",
              { key: conf.uid, attrs: { "show-handle": "" } },
              [
                _c("w-list-item-text", [_vm._v(_vm._s(_vm.getText(conf)))]),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("common.edit"),
                            expression: "$ct('common.edit')",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.editItem(conf)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "pen" } })],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("common.delete"),
                            expression: "$ct('common.delete')",
                          },
                        ],
                        staticClass: "danger",
                        on: {
                          click: function ($event) {
                            return _vm.removeItem(conf)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "w-list-item",
            {
              key: "add",
              on: {
                click: function ($event) {
                  return _vm.addClicked()
                },
              },
            },
            [
              _c(
                "w-list-item-icon",
                [_c("w-fa", { attrs: { icon: "plus" } })],
                1
              ),
              _c("w-list-item-text", [_vm._v(_vm._s(_vm.$ct("common.add")))]),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditItem != null } },
        [
          _vm.toEditItem
            ? _c("app-sale-type-calendar-settings-edit-item", {
                attrs: { value: _vm.toEditItem, "is-new": _vm.isNewEditItem },
                on: {
                  input: function ($event) {
                    return _vm.onValue($event)
                  },
                  close: function ($event) {
                    _vm.toEditItem = null
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }